import { Typography, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
const TimeDetails = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[700],
  transform: "translateY(-8px)"
}));
const TIMELINE_WIDTH = 49;
const TimeIndicatorWrapper = styled("div")(
  ({ theme, top }) => `
  position: absolute;
  pointer-events: none;
  z-index: 4;
  left: ${TIMELINE_WIDTH}px;
  width: ${`calc(100% - ${TIMELINE_WIDTH}px)`};
  top: ${top || 0}%;

  &:after,
  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    background: ${theme.palette.error[500]};
  }

  &:before {
    width: 100%;
    height: 1px;
  }

  &:after {
    width: 11px;
    height: 11px;
    border-radius: 50%;
    top: -5px;
    left: -5px;
  }
`
);
const ColumnWrapper = styled(Paper)(
  ({ theme, offset }) => `
  width: ${TIMELINE_WIDTH}px;
  flex-shrink: 0;
  text-align: center;
  border-radius: 8px 0 0 8px;
  background: ${theme.palette.common.white};
  padding-top: ${offset || 0}px;
`
);
const IntervalWrapper = styled("div")(
  ({ theme, height, lineWidth }) => `
  height: ${height}px;
  position: relative;

  &:before {
    content: '';
    z-index: 1;
    position: absolute;
    display: block;
    pointer-events: none;
    left: ${TIMELINE_WIDTH}px;
    top: 0;
    height: 1px;
    background: ${theme.palette.grey[300]};
    width: ${lineWidth ?? 1e4}px;
  }

  &:after {
    content: '';
    position: absolute;
    display: block;
    right: 0;
    top: 0;
    width: 3px;
    height: 1px;
    background: ${theme.palette.grey[300]};
  }
`
);
const TimeIndicatorInfo = styled(Typography)(({ theme }) => ({
  color: theme.palette.error[500],
  position: "absolute",
  left: "-48px",
  top: "-9px",
  zIndex: 3,
  background: theme.palette.common.white,
  padding: "2px 4px"
}));
export {
  ColumnWrapper,
  IntervalWrapper,
  TimeDetails,
  TimeIndicatorInfo,
  TimeIndicatorWrapper
};
